export default __webpack_public_path__ + "static/retroexcavadoras-d07ec5faa6b549c0e5bf6636af96d6ff.png";